import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { List, ListItem } from "../components/List";
import { useCallback, useEffect, useState } from "react";
import { $getSelection, $isRangeSelection } from "lexical";
import { $getSelectionStyleValueForProperty, $patchStyleText } from '@lexical/selection';
import { useIntl } from "react-intl";

export const FontSizes =
[
    '4px', '5px', '6px', '7px', '8px', '9px', '10px', '11px', '12px', '14px', '18px', '24px', '30px', '36px', '48px', '60px', '72px', '96px',
    '1em', '2em', '3em', '4em',
    '1rem', '2rem', '3rem', '4rem',
    '1vw', '2vw', '3vw', '4vw', '5vw', '6vw', '7vw', '8vw', '9vw', '10vw', '11vw', '12vw', '13vw', '14vw', '15vw', '16vw',
    '10%', '20%', '30%', '40%', '50%', '60%', '70%', '80%', '90%', '100%', '110%', '120%', '130%', '140%', '150%', '160%', '170%', '180%', '190%', '200%', '210%', '220%', '230%', '240%', '250%', '260%', '270%', '280%', '290%', '300%'
];

const DefaultSize = '';

export function FontSize()
{
    const [editor] = useLexicalComposerContext();
    const intl = useIntl();
    const translations = (intl as any).messages?.sharedComponents?.lexicalEditor?.toolbar;
    const [value, setValue] = useState(DefaultSize);
    useEffect(() =>
    {
        return editor.registerUpdateListener(({ editorState }) =>
        {
            editorState.read(() =>
            {
                const selection = $getSelection();
                if (!$isRangeSelection(selection)) { return; }
                const size = $getSelectionStyleValueForProperty(selection, 'font-size', DefaultSize);
                setValue(size);
            });
        });
    },
    [editor]);
    const handleOnChange = useCallback(value =>
    {
        editor.update(() =>
        {
            const selection = $getSelection();
            if ($isRangeSelection(selection))
            {
                $patchStyleText(selection, { 'font-size': value });
            }
        });
    },
    [editor]);
    const element =
    <List value={value} title={value} onChange={handleOnChange} placeholder={translations?.fontSizePlaceholder ?? 'Size'} className="menu block-type-list">
        {FontSizes.map(size => <ListItem key={size} value={size} title={size} tag='span' />)}
    </List>;
    return element;
}
